import { render, staticRenderFns } from "./aiReviewBar.vue?vue&type=template&id=352e0356&scoped=true"
import script from "./aiReviewBar.vue?vue&type=script&lang=js"
export * from "./aiReviewBar.vue?vue&type=script&lang=js"
import style0 from "./aiReviewBar.vue?vue&type=style&index=0&id=352e0356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e0356",
  null
  
)

export default component.exports